module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-input",
    class: _vm.classes
  }, [(_vm.$props.noResize || _vm.$props.type != 'text') ? _c('div', {
    staticClass: "z-input-container"
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s((_vm.$props.label + ((_vm.$props.required) ? '<span>*</span>' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : '')))
    }
  }) : _vm._e(), ((_vm.$props.type) === 'checkbox' && (_vm.$props.mask)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.$props.mask),
      expression: "$props.mask"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.$props.type) === 'radio' && (_vm.$props.mask)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.$props.mask),
      expression: "$props.mask"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : (_vm.$props.mask) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.$props.mask),
      expression: "$props.mask"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": _vm.$props.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : ((_vm.$props.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.$props.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength,
      "type": _vm.$props.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "wheel": _vm.onWheel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }), _c('div', {
    ref: "shadow",
    staticClass: "shadow-height"
  }, [_vm._v(_vm._s(_vm.val))])]) : _c('div', {
    staticClass: "z-input-container"
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s((_vm.$props.label + ((_vm.$props.required) ? '<span>*</span>' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : '')))
    }
  }) : _vm._e(), (_vm.$props.mask) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.$props.mask),
      expression: "$props.mask"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": _vm.$props.type,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": _vm.$props.type,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }), _c('div', {
    ref: "shadow",
    staticClass: "shadow-height"
  }, [_vm._v(_vm._s(_vm.val))])]), _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('md-progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.loading),
      expression: "$props.loading"
    }],
    staticClass: "progress-bar",
    attrs: {
      "md-mode": "indeterminate"
    }
  })], 1), _vm._t("default"), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246a0232","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInput.vue
// module id = 1071
// module chunks = 0